import type { WalletBalanceSource } from '../lib/walletSource';

export default function WalletSourceIcon({ source }: { source: WalletBalanceSource }) {
  if (source === 'world-app') {
    return <img className="wallet-source-icon" src="/image/world-id-logo.png" alt="" aria-hidden="true" />;
  }

  return <img className="wallet-source-icon" src="/image/metamask_02.png" alt="" aria-hidden="true" />;
}
